/* app/onboarding/confetti.js — лёгкое праздничное конфетти без зависимостей.
   Рисует короткий canvas-всплеск поверх оверлея и сам себя убирает. Уважает
   prefers-reduced-motion (тогда не показывается вовсе). Используется в момент
   создания первой ТТК в игровом онбординге. */

export function fireConfetti(opts = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  const duration = opts.duration || 1700;
  const colors = opts.colors || ['#3776FE', '#22C55E', '#F59E0B', '#EC4899', '#8B5CF6', '#06B6D4'];

  const canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  Object.assign(canvas.style, {
    position: 'fixed', inset: '0', width: '100%', height: '100%',
    pointerEvents: 'none', zIndex: '997',
  });
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  let W = 0, H = 0;
  const resize = () => { W = canvas.width = window.innerWidth * dpr; H = canvas.height = window.innerHeight * dpr; };
  resize();

  const N = opts.count || 150;
  const cx = (opts.originX != null ? opts.originX : 0.5) * W;
  const cy = (opts.originY != null ? opts.originY : 0.4) * H;
  const parts = Array.from({ length: N }, () => {
    const ang = Math.PI * 2 * Math.random();
    const sp = (4 + Math.random() * 9) * dpr;
    return {
      x: cx, y: cy,
      vx: Math.cos(ang) * sp,
      vy: Math.sin(ang) * sp - 6 * dpr,
      g: 0.3 * dpr,
      w: (5 + Math.random() * 7) * dpr,
      h: (8 + Math.random() * 9) * dpr,
      rot: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.4,
      color: colors[(Math.random() * colors.length) | 0],
      life: 1,
    };
  });

  const start = (window.performance && performance.now) ? performance.now() : Date.now();
  let raf = 0;
  const cleanup = () => {
    if (raf) cancelAnimationFrame(raf);
    window.removeEventListener('resize', resize);
    if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
  };
  const tick = (now) => {
    const elapsed = ((window.performance && performance.now) ? now : Date.now()) - start;
    ctx.clearRect(0, 0, W, H);
    for (const p of parts) {
      p.vy += p.g; p.vx *= 0.99;
      p.x += p.vx; p.y += p.vy; p.rot += p.vr;
      if (elapsed > duration * 0.55) p.life -= 0.022;
      if (p.life <= 0) continue;
      ctx.save();
      ctx.globalAlpha = Math.max(0, p.life);
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    }
    if (elapsed < duration) raf = requestAnimationFrame(tick);
    else cleanup();
  };
  window.addEventListener('resize', resize);
  raf = requestAnimationFrame(tick);
}
